module.exports = __webpack_public_path__ + "img/corp-wfrj_2x.13909fe0.jpg";